import { createSlice } from "@reduxjs/toolkit";

interface CustomerFormMemory {
  customerId: number | null;
  values: Record<string, any>;
}

interface FormMemoryState {
  bookingForm: Record<string, any> | null;
  courseBookingForm: Record<string, any> | null;
  customerForm: CustomerFormMemory | null;
  animalForm: Record<string, any> | null;
}

const initialState: FormMemoryState = {
  bookingForm: null,
  courseBookingForm: null,
  customerForm: null,
  animalForm: null,
};

// we need this slice to keep booking form in memory while creatng a new animal or customer
// and recover the data after coming back to the booking

const formMemorySlice = createSlice({
  name: "formMemory",
  initialState,
  reducers: {
    setBookingForm(state, action) {
      state.bookingForm = action.payload;
    },
    clearBookingForm(state) {
      state.bookingForm = null;
    },
    setServiceBookingForm(state, action) {
      state.courseBookingForm = action.payload ?? null;
    },
    clearServiceBookingForm(state) {
      state.courseBookingForm = null;
    },
    setBookingDraftOccupancies(state, action) {
      state.bookingForm = {
        ...(state.bookingForm ?? {}),
        draftOccupancies: action.payload ?? {},
      };
    },
    setBookingFormValue(state, action) {
      state.bookingForm = {
        ...(state.bookingForm ?? {}),
        [action.payload.key]: action.payload.value,
      };
    },
    appendBookingFormValue(state, action) {
      const { key, value } = action.payload;
      const existing = (state.bookingForm ?? {})[key];
      state.bookingForm = {
        ...(state.bookingForm ?? {}),
        [key]: Array.isArray(existing)
          ? existing.includes(value)
            ? existing
            : [...existing, value]
          : [value],
      };
    },
    // ggf. analog für Customer/Animal
    setCustomerForm(state, action) {
      state.customerForm = action.payload ?? null;
    },
    clearCustomerForm(state) {
      state.customerForm = null;
    },
  },
});

export const {
  setBookingForm,
  clearBookingForm,
  setServiceBookingForm,
  clearServiceBookingForm,
  setBookingDraftOccupancies,
  setBookingFormValue,
  appendBookingFormValue,
  setCustomerForm,
  clearCustomerForm,
} = formMemorySlice.actions;

export default formMemorySlice.reducer;
